import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const first = document.getElementById('first-cta');
      if (!first) return;
      setVisible(first.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-139" data-mp="brau15bzcen8">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" data-id="element-140" data-mp="bqix9r6ncavd">
          <div className="mx-auto max-w-md" data-id="element-141" data-mp="2b38rjkh3qwuy">
            <CtaButton label="Get my deck for $27" size="md" shake data-id="element-142" data-mp="2f3sl6e2gvicc" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}